module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vback3-132bf879ac7a7059487f35d9cd4cdd74.jpg";